module.exports = __webpack_public_path__ + "static/media/na.9cc16b5c.svg";